import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

type LegendItemProps = {
  label: string;
  totalPercent?: number;
  color: string;
  valueFormatter: (value: number) => string;
};

export const LegendItem = ({ label, totalPercent, color, valueFormatter }: LegendItemProps) => {
  const hasTotal = totalPercent != null && Number.isFinite(totalPercent);
  const text = hasTotal ? `${label} — ${valueFormatter(totalPercent)}` : label;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} data-test="pyramid-diagram-legend-item">
      <Box
        sx={{
          width: 12,
          height: 12,
          borderRadius: '2px',
          backgroundColor: color,
          flexShrink: 0,
        }}
        data-test="pyramid-diagram-legend-swatch"
      />
      <Typography variant="body1" sx={{ color: 'text.primary' }}>
        {text}
      </Typography>
    </Box>
  );
};
